/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowUiAuthLogoutIcon16Light = forwardRef('ArrowUiAuthLogoutIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { d: "M5.75 2A1.75 1.75 0 0 0 4 3.75v7.5c0 .966.784 1.75 1.75 1.75H9.5a.5.5 0 0 1 0 1H5.75A2.75 2.75 0 0 1 3 11.25v-7.5A2.75 2.75 0 0 1 5.75 1H9.5a.5.5 0 0 1 0 1H5.75Z" }),
        React.createElement("path", { d: "M11.127 4.164a.5.5 0 0 0 .035.707L13.515 7H6.5a.5.5 0 0 0 0 1h7.015l-2.353 2.13a.5.5 0 1 0 .671.74l2.7-2.443a1.25 1.25 0 0 0 0-1.854l-2.7-2.444a.5.5 0 0 0-.706.035Z" })));
});
